var a = Object.defineProperty;
var p = (r, o, e) => o in r ? a(r, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[o] = e;
var s = (r, o, e) => p(r, typeof o != "symbol" ? o + "" : o, e);
class m {
  constructor() {
    s(this, "isValid", !1);
    s(this, "provider", "");
    s(this, "id", "");
  }
}
const c = [
  {
    provider: "youtube",
    regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/
  },
  {
    provider: "youtube",
    regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/shorts\/)([\w-]{11})(?:\S+)?$/
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)\/([\w-]+)/i
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)\?h=([\w-]+)/i
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)(?:\/)?/i
  },
  {
    provider: "wistia",
    regex: /wistia\..*\/([^?]+)\??.*/i
  },
  {
    provider: "loom",
    regex: /(?:use)?loom\..*\/([^?]+)\??.*/i
  },
  {
    provider: "vidyard",
    regex: /vidyard\..*\/([^?]+)\??.*/i
  },
  {
    provider: "brightcove",
    regex: /players\.brightcove\.net\/([^\/]+)\/.*videoId=([\w-]+)/i
  },
  {
    provider: "jwplayer",
    regex: /(?:cdn|content)\.jwplatform\.com\/players\/([\w-]+)\.html/i
  },
  {
    provider: "microsoftstream",
    regex: /web\.microsoftstream\.com\/embed\/video\/([\w-]+)/i
  },
  {
    provider: "microsoftstream",
    regex: /^(?:https?:\/\/)?([\w-]+)\.sharepoint\.com\/:v:\/(.*)/i
  },
  {
    provider: "synthesia",
    regex: /share\.synthesia\.io\/embeds\/videos\/([\w-]+)/i
  },
  {
    provider: "synthesia",
    regex: /share\.synthesia\.io\/([\w-]+)/i
  },
  {
    provider: "guidde",
    regex: /embed\.app\.guidde\.com\/playbooks\/([\w-]+)/i
  },
  {
    provider: "descript",
    regex: /share\.descript\.com\/(?:embed|view)\/([\w-]+)/i
  },
  {
    provider: "guideflow",
    regex: /app\.guideflow\.com\/(?:embed|video|player)\/([\w-]+)/i
  },
  {
    provider: "supademo-showcase",
    regex: /app\.supademo\.com\/showcase\/embed\/([\w-]+)/i
  },
  {
    provider: "supademo-showcase",
    regex: /app\.supademo\.com\/showcase\/([\w-]+)/i
  },
  {
    provider: "supademo",
    regex: /app\.supademo\.com\/embed\/([\w-]+)/i
  },
  {
    provider: "supademo",
    regex: /supademo\.com\/demo\/([\w-]+)/i
  }
], i = "|";
function h(r) {
  let o = new m();
  return r && (r = r.trim(), c.some((e) => {
    let t = r.match(e.regex);
    if (t) {
      let [, ...d] = t;
      return o.provider = e.provider, o.id = d.join(i), o.isValid = !0, !0;
    } else
      return !1;
  })), o;
}
function v(r, o) {
  let [e, ...t] = o.split(i);
  switch (r) {
    case "youtube":
      return `https://www.youtube.com/embed/${e}?rel=0`;
    case "vimeo":
      return t.length === 0 ? `https://player.vimeo.com/video/${e}` : `https://player.vimeo.com/video/${e}?h=${t[0]}`;
    case "wistia":
      return `https://fast.wistia.net/embed/iframe/${e}`;
    case "loom":
      return `https://www.loom.com/embed/${e}`;
    case "vidyard":
      return `https://play.vidyard.com/${e}`;
    case "brightcove":
      return `https://players.brightcove.net/${e}/default_default/index.html?videoId=${t[0]}`;
    case "jwplayer":
      return `https://content.jwplatform.com/players/${e}.html`;
    case "microsoftstream":
      return t.length === 0 ? `https://web.microsoftstream.com/embed/video/${e}` : `https://${e}.sharepoint.com/:v:/${t[0]}`;
    case "synthesia":
      return `https://share.synthesia.io/embeds/videos/${e}`;
    case "guidde":
      return `https://embed.app.guidde.com/playbooks/${e}`;
    case "descript":
      return `https://share.descript.com/embed/${e}`;
    case "guideflow":
      return `https://app.guideflow.com/embed/${e}`;
    case "supademo":
      return `https://app.supademo.com/embed/${e}`;
    case "supademo-showcase":
      return `https://app.supademo.com/showcase/embed/${e}`;
    default:
      throw new Error(`Video provider ${r} not supported`);
  }
}
export {
  v as generateVideoUrl,
  h as parseUrl
};
